import { render, staticRenderFns } from "./xxcx.vue?vue&type=template&id=018686ec&"
import script from "./xxcx.vue?vue&type=script&lang=js&"
export * from "./xxcx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports